import { gql } from '@apollo/client';

const getActiveOffer = gql`
  query VerifyActiveOffer($email: String!, $sellerInputUUID: String, $addressUUID: String) {
    sellDirect {
      verifyActiveOffer(
        input: { email: $email, sellerInputUuid: $sellerInputUUID, addressUuid: $addressUUID }
      ) {
        offer {
          id
          offerDashboardUrl
          experiencePartner {
            name
            email
            displayPhoneNumber
            photoUrl
            brokerageLicenses {
              geographicState
              licenseNumber
            }
          }
        }
      }
    }
  }
`;

export default getActiveOffer;
